import { mapGetters } from 'vuex'
import { GETTERS } from '@/store'

export default {
  computed: {
    ...mapGetters({
      deviceWidth: GETTERS.GET_DEVICE_WIDTH
    }),
    bpSm () {
      return 'bp-sm'
    },
    bpMd () {
      return 'bp-md'
    },
    bpLg () {
      return 'bp-lg'
    },
    bpHd () {
      return 'bp-hd'
    },
    deviceWidthClass () {
      const classes = {
        767: this.bpSm,
        768: this.bpMd,
        1120: this.bpLg,
        1200: this.bpHd
      }

      const width = Object.keys(classes).find(key => {
        if (this.deviceWidth <= key) {
          return key
        }
      })

      return classes[width] || ''
    }
  }
}
